import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "../styles.css";
import axios from "axios";
import ListMenu from "./ListMenu";
import Messaging from "./Mesaging";
import { useNavigate, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom"; // Import Navigate
import { randomNumber } from "../functions/RandomNumber";
import { API_IP } from "../global_variables";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { DropdownItem } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const NavBar = ({
  loggedIn,
  setLogin,
  setSelectedSection,
  toggleSidebar,
  setSelectedCareService,
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [services, setServices] = useState([]);
  const navigate = useNavigate();
  const [isServiceOpen, setIsServiceOpen] = useState(false); // State to control component visibility
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const componentRef = useRef(null); // Reference to the component
  const componentProfileRef = useRef(null);
  const toggleService = () => setIsServiceOpen(!isServiceOpen);
  const toggleProfile = () => setIsProfileOpen(!isProfileOpen);
  const [showNavbar, setShowNavbar] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;
  const toggle = () => setIsOpen(!isOpen);
  const handleClickOutside = (event) => {
    // Check if click is outside the component
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setIsServiceOpen(false); // Close the component when clicked outside
    }
    if (
      componentProfileRef.current &&
      !componentProfileRef.current.contains(event.target)
    ) {
      setIsProfileOpen(false); // Close the component when clicked outside
    }
  };

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API_IP}/api/services`); // Update with your API endpoint
      setServices(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const profileMenuList = [
    { name: "Account", screen: "Account", function: null },
    { name: "Calendar", screen: "Calendar" },
    { name: "Self/Family Profiles", screen: "Patient" },
  ];

  useEffect(() => {
    fetchServices();
    const checkScreenWidth = () => {
      setShowNavbar(window.innerWidth <= 960);
    };
    checkScreenWidth();
    window.addEventListener("resize", checkScreenWidth);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", checkScreenWidth);
    };
  }, []);

  // For the Services dropdown.
  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const imgList = {
    Bathing: 13,
    Laundry: 12,
    "Groccery Shopping": 11,
    Transferring: 10,
    Eating: 9,
    "Personal Errands": 8,
    Showers: 7,
    Dressing: 6,
    "Hygiene/Grooming": 5,
    "Meal Preparation": 4,
    "Declutter/Organization": 3,
    Ambulating: 2,
    "Medication Management": 1,
    "Transport to/from appointments": 10,
  };

  const handleLogout = () => {
    const keys = ["token", "username", "userId", "isAdmin"];
    keys.forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    navigate("/");
    setLogin(false);
  };

  return (
    <>
      <Navbar
        expand={false}
        style={{ display: showNavbar ? "block" : "none" }}
        className="background-color-navbar"
      >
        <Container className="navbar-resized-container">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Brand href="#home">
            <Link className="logoContainer" to="/">
              <img
                className="logo"
                src={require("../images/iCareVillage_logo.webp")}
                alt="logo"
              />
            </Link>
          </Navbar.Brand>

          {currentPath === "/UserHome" ? (
            <button
              onClick={() => {
                toggleSidebar();
              }}
              className="navbar-button"
            >
              <img
                className="navbar-button-resized"
                src={require("../images/house_icon.png")}
                alt="logo"
              />
            </button>
          ) : (
            <div></div>
          )}

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="navbar-collapse-resized"
          >
            <Nav className="me-auto">
              <Navbar.Collapse
                id="basic-navbar-nav"
                className="navbar-collapse-resized"
              >
                <Nav className="me-auto">
                  {loggedIn ? (
                    <NavDropdown.Item onClick={() => navigate("/main")}>
                      Home
                    </NavDropdown.Item>
                  ) : (
                    <></>
                  )}

                  <NavDropdown
                    className="nav-item-resized"
                    title="Contact Us"
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item
                      onClick={() => {
                        navigate("/AboutUs");
                      }}
                    >
                      Our Company
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => {
                        navigate("/OurLeadership");
                      }}
                    >
                      Our Leadership
                    </NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown.Item onClick={() => navigate("/AboutUs")}>
                    About Us
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/ContactUs")}>
                    Contact Us
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/Careers")}>
                    Careers
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/consultation")}>
                    <div className="consultationMobileButton">
                      <p>FREE in-home or virtual consultation</p>
                    </div>
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => navigate("/platform-orientation")}
                  >
                    <div className="orientationMobileButton">
                      Platform Orientation
                    </div>
                  </NavDropdown.Item>
                </Nav>
              </Navbar.Collapse>
              <NavDropdown
                className="nav-item-resized"
                title="Service+"
                id="basic-nav-dropdown"
              >
                {services.map((service, index) => (
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(`/CareServiceProfile`, {
                        state: {
                          data: service,
                          imgIndex: imgList[service.care_service_name],
                        },
                      });
                      toggleService();
                    }}
                    key={index}
                  >
                    {service.care_service_name}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
              {loggedIn ? (
                <>
                  <NavDropdown
                    className="nav-item-resized"
                    title="My Profile"
                    id="basic-nav-dropdown"
                  >
                    {profileMenuList.map((profile, index) => (
                      <NavDropdown.Item
                        onClick={() => {
                          toggleService();
                          toggleSidebar(false);
                          setSelectedSection(profile.screen);
                          navigate("/UserHome");
                        }}
                        key={index}
                      >
                        {profile.name}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                  <NavDropdown.Item onClick={handleLogout}>
                    Log Out
                  </NavDropdown.Item>
                </>
              ) : (
                <>
                  <NavDropdown.Item onClick={() => navigate("/login")}>
                    Log In
                  </NavDropdown.Item>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <nav className="navbar-fullscreen">
        <Link className="logoContainer" to="/">
          <img
            className="logo"
            src={require("../images/iCareVillage_logo.webp")}
            alt="logo"
          />
        </Link>

        <ul className="navList montserrat">
          <>
            {loggedIn ? (
              <li>
                <Link className="navbuttons decorationNone" to="/main">
                  Home
                </Link>
              </li>
            ) : (
              <></>
            )}
            <li>
              <Link className="navbuttons decorationNone" to="/Services">
                Services
              </Link>
            </li>
            <li className="dropdown-about-us">
              <Link
                className="navbuttons decorationNone"
                to="/AboutUs"
                onClick={toggleDropdown}
              >
                About Us
              </Link>
              <div className="dropdown-about-us-content">
                <a href="/AboutUs">Our Company</a>
                <a href="/OurLeadership">Our Leadership</a>
              </div>
            </li>
            <li>
              <Link className="navbuttons decorationNone" to="/ContactUs">
                Contact Us
              </Link>
            </li>
            <li>
              <Link className="navbuttons decorationNone" to="/Careers">
                Careers
              </Link>
            </li>
            <li>
              <Link
                className="booking_consultation_button decorationNone"
                to="/consultation"
              >
                FREE in-home or virtual consultation
              </Link>
            </li>
            <li>
              <Link
                to="/platform-orientation"
                className="navbarItem navHighlightBtn"
              >
                Platform Orientation
              </Link>
            </li>
          </>
        </ul>

        <ul className="navlogin montserrat">
          {loggedIn ? (
            <>
              <button
                className="service-button-item"
                onClick={() => setIsServiceOpen(!isServiceOpen)}
                style={{ marginLeft: "60px" }}
              >
                Services+
              </button>
              {isServiceOpen &&
                (loggedIn ? (
                  <ListMenu
                    componentRef={componentRef}
                    title="Service"
                    toggleService={toggleService}
                    navListData={services}
                    setSelectedCareService={setSelectedCareService}
                  />
                ) : (
                  <Navigate to="/login" />
                ))}
              <button
                className="service-button-item"
                onClick={() => {
                  setIsProfileOpen(!isProfileOpen);
                }}
              >
                My Profile
              </button>
              {isProfileOpen ? (
                <ListMenu
                  componentRef={componentProfileRef}
                  title="My Profile"
                  toggleService={toggleProfile}
                  navListData={profileMenuList}
                  switchScreen={setSelectedSection}
                />
              ) : (
                <></>
              )}
            </>
          ) : (
            <li>
              <button
                className="service-button-item"
                onClick={() => {
                  navigate("/register");
                }}
              >
                Register
              </button>
            </li>
          )}

          <li>
            {loggedIn ? (
              <button className="service-button-item" onClick={handleLogout}>
                Log Out
              </button>
            ) : (
              <button
                onClick={() => {
                  navigate("/login");
                }}
                className="service-button-item"
              >
                Log In
              </button>
            )}
          </li>
        </ul>
      </nav>
    </>
  );
};

export default NavBar;
